import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { navLinks, siteName } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
      isActive
        ? "text-primary-600 font-medium"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200/80">
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[72px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label={`${siteName} 首页`}>
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
              <i className="ri-clapperboard-line text-lg md:text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-base md:text-lg text-foreground-950 tracking-tight">
                {siteName}
              </span>
              <span className="text-[10px] md:text-[11px] text-foreground-500 tracking-[0.18em] mt-0.5">
                FILM · STORY · GUIDE
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <NavLink key={link.to} to={link.to} className={linkClass} end={link.to === "/"}>
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <button
              type="button"
              onClick={() => navigate("/search")}
              aria-label="搜索影视作品与资讯"
              className="hidden md:flex items-center gap-2 h-9 pl-3 pr-3 rounded-full border border-background-300/70 text-sm text-foreground-500 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              搜索作品 / 资讯
            </button>
            <button
              type="button"
              onClick={() => navigate("/search")}
              aria-label="搜索"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开导航菜单"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200/80 bg-background-50">
          <nav className="px-4 py-3 flex flex-col">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-label transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-50 text-primary-600 font-medium"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}